<template>
  <v-sheet class="rounded-pill pa-1 float-buttons" color="white">
    <div class="d-flex item-list">
      <template v-if="config.whatsapp">
        <v-btn
          class="text-none"
          color="rgba(1, 105, 70, 0.20)"
          :href="getWhatsappLinkFromPhone(config.whatsapp)"
          target="_blank"
          :x-large="!xsOnly"
          :fab="xsOnly"
          depressed
          rounded
        >
          <v-icon :left="!xsOnly" color="rgba(1, 105, 70, 1)" size="28">
            fab fa-whatsapp
          </v-icon>

          <template v-if="!xsOnly"> Dúvidas? Fale com a gente! </template>
        </v-btn>
      </template>

      <v-btn
        v-if="config.shopping_cart"
        @click="$shoppingCart.open = !$shoppingCart.open"
        class="text-none position-relative"
        :x-large="!xsOnly"
        :fab="xsOnly"
        depressed
        rounded
      >
        <v-icon :left="!xsOnly" color="secondary" size="22">
          fas fa-shopping-cart
        </v-icon>

        <template v-if="!xsOnly"> Carrinho </template>

        <v-badge
          v-if="totalItemsCart"
          class="mb-2 cart-badge"
          color="secondary"
          :content="totalItemsCart"
          bordered
          right
          top
        ></v-badge>
      </v-btn>
    </div>
  </v-sheet>
</template>

<script>
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";

const _config = {
  mod: "config",
};

export default {
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
  computed: {
    config() {
      return this.$rest(_config.mod).item;
    },
    totalItemsCart() {
      return this.$shoppingCart.container.items.reduce(
        (r, { state: { quant } }) => r + quant,
        0
      );
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getWhatsappLinkFromPhone,
  },
};
</script>

<style lang="scss" scoped>
.float-buttons {
  bottom: 15px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  left: 50%;
  position: fixed;
  transform: translateX(-50%);

  .item-list {
    gap: 4px;
  }
}

.cart-badge::v-deep {
  .v-badge__badge {
    font-weight: medium !important;
    height: 19px;
    min-width: 19px;
  }
}
</style>
